module.exports = __webpack_public_path__ + "img/143.3c9b96f1.png";